import axios from '../utils/axios';
import moment from 'moment';

export default function uploadCsvToS3(adminId, file) {
    const currentMoment = moment();
    const formData = new FormData();
    
    // Add metadata for backend to construct S3 path and filename
    formData.append('file', file);
    formData.append('date', currentMoment.format('YYYY/MM/DD'));
    formData.append('filename', `${currentMoment.format('YYYY-MM-DD')}-${adminId}-${file.name}`);
    
    return axios.post(`/admin/${adminId}/tag-mailers/upload-csv-s3`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}